var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPlus24 = function SvgPlus24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6 5a.6.6 0 1 0-1.2 0v6.4H5.5a.6.6 0 1 0 0 1.2h5.9V19a.6.6 0 1 0 1.2 0v-6.4h5.9a.6.6 0 1 0 0-1.2h-5.9V5Z",
    fill: "#232837"
  })));
};

export default SvgPlus24;